import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import BottomNavLogic from './BottomNavLogic';

class BottomNav extends Component {
	state = {
		slug: null,
		navItem: {},
		mouseElementName: null,
	}

	changeSlug = (slug, navItem = {}) => {
		// DEV NOTE: 📌 To pin sub nav open...
		// Enable this line & last hovered cat's subnav will stay open
		// if (slug === null) return;
		this.setState({ slug, navItem });
	}

	changeMouseElementName = mouseElementName => {
		this.setState({ mouseElementName });
	}

	render () {
		const passedProps = {
			...this.state,
			changeSlug: this.changeSlug,
			changeMouseElementName: this.changeMouseElementName,
			...this.props,
		};

		return (<BottomNavLogic {...passedProps} />);
	}
}

export default hot(module)(BottomNav);
